// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IndicatorBadge-module__Container__H8gFx {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
}
/* --- Placement anchors --- */

.IndicatorBadge-module__BottomRight__zPGFK {
    right: 0;
    bottom: 0;
}

.IndicatorBadge-module__TopRight__eRY_J {
    top: 0;
    right: 0;
}
/* --- Placement + Size position offsets --- */

.IndicatorBadge-module__BottomRightSmall__RZsFU {
    transform: translate(calc(100% - var(--ds-sm)), calc(100% - var(--ds-sm)));
}

.IndicatorBadge-module__BottomRightTiny__hRgXl {
    transform: translate(calc(100% - var(--ds-s)), calc(100% - var(--ds-s)));
}

.IndicatorBadge-module__TopRightLarge__rQ6CO {
    transform: translate(calc(100% - var(--ds-l)), calc(-100% + var(--ds-l)));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `IndicatorBadge-module__Container__H8gFx`,
	"BottomRight": `IndicatorBadge-module__BottomRight__zPGFK`,
	"TopRight": `IndicatorBadge-module__TopRight__eRY_J`,
	"BottomRightSmall": `IndicatorBadge-module__BottomRightSmall__RZsFU`,
	"BottomRightTiny": `IndicatorBadge-module__BottomRightTiny__hRgXl`,
	"TopRightLarge": `IndicatorBadge-module__TopRightLarge__rQ6CO`
};
export default ___CSS_LOADER_EXPORT___;
